module.exports = __webpack_public_path__ + "static/img/52.f918b83.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/52.gif
// module id = ZgGg
// module chunks = 0